import { Backdrop, CircularProgress, Grid } from '@material-ui/core';
import { ArrowBack } from "@material-ui/icons";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Select from '../../../components/Form/Select';
import StatusByColor from '../../../components/Form/StatusByColor';
import ButtonUI from '../../../components/ui/ButtonUI';
import MvmStatus from '../../../interfaces/MvmStatus';
import MvmApi from '../../../services/MvmApi';
import utilsDate from '../../../utils/Date';
import { useStyles } from '../Style';
import { useAuth } from '../../../hooks/auth';

type props = any;

const MvmFooter: React.FC<props> = ({ control, onChange, setValue, concierges, queryMvmNumber, checkInOrOut, pngValidated, conciergeReleaseDate, status, mvmType}) => {
    const [circularLoading, setCircularLoading] = useState(false)
    const classes = useStyles();
    const { t } = useTranslation("Mvm")
    const { t: _t } = useTranslation("General")
    const { user } = useAuth();

    useEffect(() => {
        if (queryMvmNumber) {
            setValue("queryMvmNumber", queryMvmNumber)
            search({label: queryMvmNumber})
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryMvmNumber])

    function search(data: any) {
        if (data && data.label !== "") {
            setCircularLoading(true)
            
            MvmApi.getMvmByMvmNumber(data.label, user.company.plantID, [])
                .then(result => {
                    if (result) {
                        setValue("shippingSupplier", result.shippingSupplierCorporateName || '')
                        setValue("mvmType", result.mvmType || '')
                        setValue("submitDate", utilsDate.DateTimeShort(result.submitDate)  || '')
                        setValue("entranceDate", utilsDate.DateTimeShort(result.entranceDate) || '')
                        setValue("vehiclePlateNumber", result.vehiclePlateNumber || '')
                        setValue("vehicleTypeDescription", result.vehicleTypeDescription || '')
                        setValue("driverName", result.driverName || '')
                        setValue("helperQuantity", result.helperQuantity || '')
                        setValue("cTeNumber", result.cTeNumber || '')
                        setValue("shippingCompanySupplier", result.shippingCompanySupplierCorporateName || '')
                        
                        onChange(result)
                        
                    } else {
                    }
                }).catch(() => {
                    onChange(null)
                }).finally(() => {
                    setCircularLoading(false);
                })
        }
    }

    const list = concierges?.map((item: any) => ({ code: item.code.toString(), label: `${item.code.toString()}` })); 
  
    return (
        <>
            <div className={classes.rootContent}>
                <Backdrop style={{ zIndex: 9999 }} open={circularLoading}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Grid container spacing={1}>                                                           
                    <Grid item xs={2} style={{marginRight:10}}>
                        <Select 
                            label={t(status === MvmStatus.FLAG_STATUS_PENDING_ENTRANCE ? "entryConcierge" : "exitConcierge")}
                            name={'concierge'}
                            control={control} 
                            style={{width: '100%'}}
                            options={list}
                            allowSelectValueNotFound={false}
                            fullwidth
                        />    
                    </Grid>

                    <Grid item xs={3}>
                        <StatusByColor
                        label={t("validatedPNG")}
                        text={pngValidated ? t("S") : t("N")}
                        color={pngValidated ? "green" : "red"} />
                    </Grid>
                    
                    <Grid item xs={3}>
                        <StatusByColor
                        label={t("conciergeCleared")}
                        text={["J", "E", "F"].includes(mvmType) ? t("S") : (conciergeReleaseDate != null ? utilsDate.DateTimeShort(conciergeReleaseDate) : t("N"))}
                        color={conciergeReleaseDate != null || ["J", "E", "F"].includes(mvmType) ? "green" : "red"} />
                    </Grid>
                </Grid>

                <Grid item>
                    <ButtonUI
                        style={{ marginTop: 15 }}
                        variant="outlined"
                        color="secondary"
                        onClick={() => window.location.reload()}
                        startIcon={<ArrowBack />}
                    >
                        {_t("back")}
                    </ButtonUI>
                    {status === MvmStatus.FLAG_STATUS_PENDING_ENTRANCE ? (
                        <ButtonUI onClick={() => checkInOrOut() } 
                        style={{marginTop:"15px", 
                        backgroundColor: 'green', 
                        color:'#FFF', 
                        borderColor: 'green'}}>
                        {t("registerEntrance")}
                    </ButtonUI>
                    ) : (
                        <ButtonUI onClick={() => checkInOrOut() } 
                        style={{marginTop:"15px", 
                        backgroundColor: 'red', 
                        color:'#FFF', 
                        borderColor: 'red'}}>
                        {t("registerExit")}
                    </ButtonUI>
                    )}
                                    
                </Grid>              
                    
            </div>
        </>
    )
}

export default MvmFooter

